export const V3IconDotsHorizontal = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" className={className}>
        <circle cx="3.5" cy="8" r="1.5" fill="#abb0ba" />
        <circle cx="8" cy="8" r="1.5" fill="#abb0ba" />
        <circle cx="12.5" cy="8" r="1.5" fill="#abb0ba" />
    </svg>
);
